import React, { Component } from "react";
import { connect } from "react-redux";
import { getConnectedUsersWS, disconnectAllUsersWS } from "services/websocket";
import { Button, List, Grid, Header, Popup } from "semantic-ui-react";
import moment from "moment";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
		height: "100%",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
};
class Notice extends Component {
	constructor(props) {
		super(props);

		this.state = {
			users: [],
		};
	}
	componentDidMount() {
		this.props.getConnectedUsersWS().then((res) => {
			this.setState({ users: res.payload.data.users });
		});
	}
	render() {
		return (
			<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
				<Grid.Column style={{ maxWidth: 950, padding: "50 20", margin: "auto", height: "93vh" }}>
					<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)" }}></Header>
					<div style={styles.blocHeader}>
						<h3>{this.state.users.length} utilisateurs connectés</h3>
					</div>
					<div style={styles.blocWhite}>
						<div style={{ margin: "10px" }}>
							<Button
								onClick={() =>
									this.props.disconnectAllUsersWS().then(() =>
										this.props.getConnectedUsersWS().then((res) => {
											this.setState({ users: res.payload.data.users });
										})
									)
								}
							>
								Reset du WS
							</Button>
						</div>
						<div>
							<List divided relaxed>
								{this.state.users &&
									this.state.users.length > 0 &&
									this.state.users.map((u) => (
										<List.Item key={u.id}>
											<Popup
												content={u.role === "NURSE" ? "Fonction: infirmier·ère" : "Fonction: secrétaire"}
												trigger={<List.Icon name={u.role === "NURSE" ? "doctor" : "user"} size="large" verticalAlign="middle" />}
											/>
											<List.Content>
												<List.Header>
													{u.username} ({u.email} #{u.id})
												</List.Header>
												<List.Description>Actif à {moment(u.activeAt).format("HH:mm")}</List.Description>
											</List.Content>
										</List.Item>
									))}
							</List>
						</div>
					</div>
				</Grid.Column>
			</Grid>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		connectedUsers: state.admin,
	};
};

const mapDispatchToProps = {
	getConnectedUsersWS,
	disconnectAllUsersWS,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notice);
